import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { CARBON_OFFSET_CONTRACTS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchContracts = () => {
  return useQuery({
    queryKey: [CARBON_OFFSET_CONTRACTS_QUERY_KEY],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: "/api/carbon_offset/contracts",
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};
